import React, { Component } from "react";
import { Modal, Form, Input, FormInstance } from "antd";

interface FormProps {
    data: any
    visible: boolean,
    failData: string,
    confirmLoading: boolean,
    onCreate: (values: any) => void,
    onCancel: () => void,
}

class UpdateIns extends Component<FormProps> {
    
    formRelf;
    constructor (props) {
        super(props);
        this.formRelf = React.createRef<FormInstance>();
    }

    render () {

        const { 
            visible, onCancel, onCreate, data,
            confirmLoading, failData
         } = this.props;
        const layout = {
            labelCol: { span: 5 },
            wrapperCol: { span: 16 },
        };

        return (
            <Modal
                maskClosable={false}
                destroyOnClose={true}
                open={visible}
                confirmLoading={confirmLoading}
                title='编辑店铺名称'
                okText='确定'
                cancelText='取消'
                onCancel={onCancel}
                onOk={
                    () => {
                        this.formRelf.current!.validateFields().then(values => {
                            onCreate(values);
                        }).catch(info => {
                            console.log('Valide Failed:', info);
                        })
                    }
                }
            >
                <Form
                    {...layout}
                    ref={this.formRelf}
                    layout='horizontal'
                    name='form'
                    initialValues={{
                        name: data.name,
                    }}
                    >
                    <Form.Item label='店铺名称' name="name" rules={[{required: true}]}>
                        <Input />
                    </Form.Item>
                </Form>
                <p className="error-center">{failData}</p>
            </Modal>
        )
    }
}

export default UpdateIns